// const publicKey = "pk_live_573e89cd8bd75e0917ee01ebaf2b5fd22d3e2963";
// export default publicKey;

const publicKey = "pk_live_7637e2dc9a92729ff7bfb5dafcb313178f0aeade";
// const publicKey = "pk_test_7bd1d9e49704be231fb25f051061192f97ab6bfd";
export default publicKey;
